// eslint-disable-next-line import/prefer-default-export
export const wellColorEnum = {
  '1-1': {value: '#ff2266', fontColor: '#ffffff'},
  '1-2': {value: '#803300', fontColor: '#ffffff'},
  '1-3': {value: '#008000', fontColor: '#ffffff'},
  '1-4': {value: '#008080', fontColor: '#ffffff'},
  '1-5': {value: '#000050', fontColor: '#ffffff'},
  '1-6': {value: '#800080', fontColor: '#ffffff'},
  '1-7': {value: '#580000', fontColor: '#ffffff'},
  '1-8': {value: '#aa3300', fontColor: '#ffffff'},
  '1-9': {value: '#005000', fontColor: '#ffffff'},
  '1-10': {value: '#005080', fontColor: '#ffffff'},
  '1-11': {value: '#280078', fontColor: '#ffffff'},
  '1-12': {value: '#500080', fontColor: '#ffffff'},
  '1-13': {value: '#ff2266', fontColor: '#ffffff'},
  '1-14': {value: '#803300', fontColor: '#ffffff'},
  '1-15': {value: '#008000', fontColor: '#ffffff'},
  '1-16': {value: '#008080', fontColor: '#ffffff'},
  '1-17': {value: '#000050', fontColor: '#ffffff'},
  '1-18': {value: '#800080', fontColor: '#ffffff'},
  '1-19': {value: '#580000', fontColor: '#ffffff'},
  '1-20': {value: '#aa3300', fontColor: '#ffffff'},
  '1-21': {value: '#005000', fontColor: '#ffffff'},
  '1-22': {value: '#005080', fontColor: '#ffffff'},
  '1-23': {value: '#280078', fontColor: '#ffffff'},
  '1-24': {value: '#500080', fontColor: '#ffffff'},
  '2-1': {value: '#aa0000', fontColor: '#ffffff'},
  '2-2': {value: '#ff6600', fontColor: '#ffffff'},
  '2-3': {value: '#00ff00', fontColor: '#000000'},
  '2-4': {value: '#00ffff', fontColor: '#000000'},
  '2-5': {value: '#0000ff', fontColor: '#ffffff'},
  '2-6': {value: '#ff00ff', fontColor: '#ffffff'},
  '2-7': {value: '#780000', fontColor: '#ffffff'},
  '2-8': {value: '#dc6600', fontColor: '#ffffff'},
  '2-9': {value: '#00b400', fontColor: '#ffffff'},
  '2-10': {value: '#50d278', fontColor: '#000000'},
  '2-11': {value: '#00288c', fontColor: '#ffffff'},
  '2-12': {value: '#dc00ff', fontColor: '#ffffff'},
  '2-13': {value: '#aa0000', fontColor: '#ffffff'},
  '2-14': {value: '#ff6600', fontColor: '#ffffff'},
  '2-15': {value: '#00ff00', fontColor: '#000000'},
  '2-16': {value: '#00ffff', fontColor: '#000000'},
  '2-17': {value: '#0000ff', fontColor: '#ffffff'},
  '2-18': {value: '#ff00ff', fontColor: '#ffffff'},
  '2-19': {value: '#780000', fontColor: '#ffffff'},
  '2-20': {value: '#dc6600', fontColor: '#ffffff'},
  '2-21': {value: '#00b400', fontColor: '#ffffff'},
  '2-22': {value: '#50d278', fontColor: '#000000'},
  '2-23': {value: '#00288c', fontColor: '#ffffff'},
  '2-24': {value: '#dc00ff', fontColor: '#ffffff'},
  '3-1': {value: '#800000', fontColor: '#ffffff'},
  '3-2': {value: '#ff9955', fontColor: '#000000'},
  '3-3': {value: '#aad400', fontColor: '#000000'},
  '3-4': {value: '#536c53', fontColor: '#ffffff'},
  '3-5': {value: '#2c89a0', fontColor: '#ffffff'},
  '3-6': {value: '#5f5fd3', fontColor: '#ffffff'},
  '3-7': {value: '#aa0000', fontColor: '#ffffff'},
  '3-8': {value: '#d29955', fontColor: '#000000'},
  '3-9': {value: '#78c800', fontColor: '#000000'},
  '3-10': {value: '#327853', fontColor: '#ffffff'},
  '3-11': {value: '#2850b4', fontColor: '#ffffff'},
  '3-12': {value: '#8c5fd3', fontColor: '#ffffff'},
  '3-13': {value: '#800000', fontColor: '#ffffff'},
  '3-14': {value: '#ff9955', fontColor: '#000000'},
  '3-15': {value: '#aad400', fontColor: '#000000'},
  '3-16': {value: '#536c53', fontColor: '#ffffff'},
  '3-17': {value: '#2c89a0', fontColor: '#ffffff'},
  '3-18': {value: '#5f5fd3', fontColor: '#ffffff'},
  '3-19': {value: '#aa0000', fontColor: '#ffffff'},
  '3-20': {value: '#d29955', fontColor: '#000000'},
  '3-21': {value: '#78c800', fontColor: '#000000'},
  '3-22': {value: '#327853', fontColor: '#ffffff'},
  '3-23': {value: '#2850b4', fontColor: '#ffffff'},
  '3-24': {value: '#8c5fd3', fontColor: '#ffffff'},
  '4-1': {value: '#a02c2c', fontColor: '#ffffff'},
  '4-2': {value: '#a05a2c', fontColor: '#ffffff'},
  '4-3': {value: '#89a02c', fontColor: '#000000'},
  '4-4': {value: '#5fd38d', fontColor: '#000000'},
  '4-5': {value: '#87cdde', fontColor: '#000000'},
  '4-6': {value: '#7c6f91', fontColor: '#ffffff'},
  '4-7': {value: '#642c2c', fontColor: '#ffffff'},
  '4-8': {value: '#c85a2c', fontColor: '#ffffff'},
  '4-9': {value: '#50a02c', fontColor: '#ffffff'},
  '4-10': {value: '#5fff5a', fontColor: '#000000'},
  '4-11': {value: '#64aade', fontColor: '#000000'},
  '4-12': {value: '#aa6f91', fontColor: '#ffffff'},
  '4-13': {value: '#a02c2c', fontColor: '#ffffff'},
  '4-14': {value: '#a05a2c', fontColor: '#ffffff'},
  '4-15': {value: '#89a02c', fontColor: '#000000'},
  '4-16': {value: '#5fd38d', fontColor: '#000000'},
  '4-17': {value: '#87cdde', fontColor: '#000000'},
  '4-18': {value: '#7c6f91', fontColor: '#ffffff'},
  '4-19': {value: '#642c2c', fontColor: '#ffffff'},
  '4-20': {value: '#c85a2c', fontColor: '#ffffff'},
  '4-21': {value: '#50a02c', fontColor: '#ffffff'},
  '4-22': {value: '#5fff5a', fontColor: '#000000'},
  '4-23': {value: '#64aade', fontColor: '#000000'},
  '4-24': {value: '#aa6f91', fontColor: '#ffffff'},
  '5-1': {value: '#c83737', fontColor: '#ffffff'},
  '5-2': {value: '#e6cc00', fontColor: '#000000'},
  '5-3': {value: '#338000', fontColor: '#ffffff'},
  '5-4': {value: '#00ffcc', fontColor: '#000000'},
  '5-5': {value: '#0044aa', fontColor: '#ffffff'},
  '5-6': {value: '#7f2aff', fontColor: '#ffffff'},
  '5-7': {value: '#963737', fontColor: '#ffffff'},
  '5-8': {value: '#e6aa00', fontColor: '#000000'},
  '5-9': {value: '#335000', fontColor: '#ffffff'},
  '5-10': {value: '#00ff8c', fontColor: '#000000'},
  '5-11': {value: '#507878', fontColor: '#ffffff'},
  '5-12': {value: '#b478dc', fontColor: '#ffffff'},
  '5-13': {value: '#c83737', fontColor: '#ffffff'},
  '5-14': {value: '#e6cc00', fontColor: '#000000'},
  '5-15': {value: '#338000', fontColor: '#ffffff'},
  '5-16': {value: '#00ffcc', fontColor: '#000000'},
  '5-17': {value: '#0044aa', fontColor: '#ffffff'},
  '5-18': {value: '#7f2aff', fontColor: '#ffffff'},
  '5-19': {value: '#963737', fontColor: '#ffffff'},
  '5-20': {value: '#e6aa00', fontColor: '#000000'},
  '5-21': {value: '#335000', fontColor: '#ffffff'},
  '5-22': {value: '#00ff8c', fontColor: '#000000'},
  '5-23': {value: '#507878', fontColor: '#ffffff'},
  '5-24': {value: '#b478dc', fontColor: '#ffffff'},
  '6-1': {value: '#ff0066', fontColor: '#ffffff'},
  '6-2': {value: '#ffff00', fontColor: '#000000'},
  '6-3': {value: '#44aa00', fontColor: '#ffffff'},
  '6-4': {value: '#37c8ab', fontColor: '#000000'},
  '6-5': {value: '#2a7fff', fontColor: '#ffffff'},
  '6-6': {value: '#8c37c8', fontColor: '#ffffff'},
  '6-7': {value: '#c80066', fontColor: '#ffffff'},
  '6-8': {value: '#ffdc00', fontColor: '#000000'},
  '6-9': {value: '#447800', fontColor: '#ffffff'},
  '6-10': {value: '#78b48c', fontColor: '#000000'},
  '6-11': {value: '#28b4ff', fontColor: '#000000'},
  '6-12': {value: '#ab96c8', fontColor: '#000000'},
  '6-13': {value: '#ff0066', fontColor: '#ffffff'},
  '6-14': {value: '#ffff00', fontColor: '#000000'},
  '6-15': {value: '#44aa00', fontColor: '#ffffff'},
  '6-16': {value: '#37c8ab', fontColor: '#000000'},
  '6-17': {value: '#2a7fff', fontColor: '#ffffff'},
  '6-18': {value: '#8c37c8', fontColor: '#ffffff'},
  '6-19': {value: '#c80066', fontColor: '#ffffff'},
  '6-20': {value: '#ffdc00', fontColor: '#000000'},
  '6-21': {value: '#447800', fontColor: '#ffffff'},
  '6-22': {value: '#78b48c', fontColor: '#000000'},
  '6-23': {value: '#28b4ff', fontColor: '#000000'},
  '6-24': {value: '#ab96c8', fontColor: '#000000'},
  '7-1': {value: '#d35f5f', fontColor: '#ffffff'},
  '7-2': {value: '#c8ab37', fontColor: '#000000'},
  '7-3': {value: '#00ff0f', fontColor: '#000000'},
  '7-4': {value: '#00ccff', fontColor: '#000000'},
  '7-5': {value: '#284478', fontColor: '#ffffff'},
  '7-6': {value: '#ff80e5', fontColor: '#000000'},
  '7-7': {value: '#b45f5f', fontColor: '#ffffff'},
  '7-8': {value: '#c89637', fontColor: '#000000'},
  '7-9': {value: '#50dc50', fontColor: '#000000'},
  '7-10': {value: '#00e6e6', fontColor: '#000000'},
  '7-11': {value: '#282850', fontColor: '#ffffff'},
  '7-12': {value: '#dcaaaa', fontColor: '#000000'},
  '7-13': {value: '#d35f5f', fontColor: '#ffffff'},
  '7-14': {value: '#c8ab37', fontColor: '#000000'},
  '7-15': {value: '#00ff0f', fontColor: '#000000'},
  '7-16': {value: '#00ccff', fontColor: '#000000'},
  '7-17': {value: '#284478', fontColor: '#ffffff'},
  '7-18': {value: '#ff80e5', fontColor: '#000000'},
  '7-19': {value: '#b45f5f', fontColor: '#ffffff'},
  '7-20': {value: '#c89637', fontColor: '#000000'},
  '7-21': {value: '#50dc50', fontColor: '#000000'},
  '7-22': {value: '#00e6e6', fontColor: '#000000'},
  '7-23': {value: '#282850', fontColor: '#ffffff'},
  '7-24': {value: '#dcaaaa', fontColor: '#000000'},
  '8-1': {value: '#ff80b2', fontColor: '#000000'},
  '8-2': {value: '#786721', fontColor: '#ffffff'},
  '8-3': {value: '#7c916f', fontColor: '#000000'},
  '8-4': {value: '#6f8a91', fontColor: '#ffffff'},
  '8-5': {value: '#87aade', fontColor: '#000000'},
  '8-6': {value: '#b450ff', fontColor: '#ffffff'},
  '8-7': {value: '#dc80b2', fontColor: '#000000'},
  '8-8': {value: '#aa6721', fontColor: '#ffffff'},
  '8-9': {value: '#7cb46f', fontColor: '#000000'},
  '8-10': {value: '#6faa78', fontColor: '#000000'},
  '8-11': {value: '#aaaade', fontColor: '#000000'},
  '8-12': {value: '#b42aff', fontColor: '#ffffff'},
  '8-13': {value: '#ff80b2', fontColor: '#000000'},
  '8-14': {value: '#786721', fontColor: '#ffffff'},
  '8-15': {value: '#7c916f', fontColor: '#000000'},
  '8-16': {value: '#6f8a91', fontColor: '#ffffff'},
  '8-17': {value: '#87aade', fontColor: '#000000'},
  '8-18': {value: '#b450ff', fontColor: '#ffffff'},
  '8-19': {value: '#dc80b2', fontColor: '#000000'},
  '8-20': {value: '#aa6721', fontColor: '#ffffff'},
  '8-21': {value: '#7cb46f', fontColor: '#000000'},
  '8-22': {value: '#6faa78', fontColor: '#000000'},
  '8-23': {value: '#aaaade', fontColor: '#000000'},
  '8-24': {value: '#b42aff', fontColor: '#ffffff'},
  '9-1': {value: '#ff2266', fontColor: '#ffffff'},
  '9-2': {value: '#803300', fontColor: '#ffffff'},
  '9-3': {value: '#008000', fontColor: '#ffffff'},
  '9-4': {value: '#008080', fontColor: '#ffffff'},
  '9-5': {value: '#000050', fontColor: '#ffffff'},
  '9-6': {value: '#800080', fontColor: '#ffffff'},
  '9-7': {value: '#580000', fontColor: '#ffffff'},
  '9-8': {value: '#aa3300', fontColor: '#ffffff'},
  '9-9': {value: '#005000', fontColor: '#ffffff'},
  '9-10': {value: '#005080', fontColor: '#ffffff'},
  '9-11': {value: '#280078', fontColor: '#ffffff'},
  '9-12': {value: '#500080', fontColor: '#ffffff'},
  '9-13': {value: '#ff2266', fontColor: '#ffffff'},
  '9-14': {value: '#803300', fontColor: '#ffffff'},
  '9-15': {value: '#008000', fontColor: '#ffffff'},
  '9-16': {value: '#008080', fontColor: '#ffffff'},
  '9-17': {value: '#000050', fontColor: '#ffffff'},
  '9-18': {value: '#800080', fontColor: '#ffffff'},
  '9-19': {value: '#580000', fontColor: '#ffffff'},
  '9-20': {value: '#aa3300', fontColor: '#ffffff'},
  '9-21': {value: '#005000', fontColor: '#ffffff'},
  '9-22': {value: '#005080', fontColor: '#ffffff'},
  '9-23': {value: '#280078', fontColor: '#ffffff'},
  '9-24': {value: '#500080', fontColor: '#ffffff'},
  '10-1': {value: '#aa0000', fontColor: '#ffffff'},
  '10-2': {value: '#ff6600', fontColor: '#ffffff'},
  '10-3': {value: '#00ff00', fontColor: '#000000'},
  '10-4': {value: '#00ffff', fontColor: '#000000'},
  '10-5': {value: '#0000ff', fontColor: '#ffffff'},
  '10-6': {value: '#ff00ff', fontColor: '#ffffff'},
  '10-7': {value: '#780000', fontColor: '#ffffff'},
  '10-8': {value: '#dc6600', fontColor: '#ffffff'},
  '10-9': {value: '#00b400', fontColor: '#ffffff'},
  '10-10': {value: '#50d278', fontColor: '#000000'},
  '10-11': {value: '#00288c', fontColor: '#ffffff'},
  '10-12': {value: '#dc00ff', fontColor: '#ffffff'},
  '10-13': {value: '#aa0000', fontColor: '#ffffff'},
  '10-14': {value: '#ff6600', fontColor: '#ffffff'},
  '10-15': {value: '#00ff00', fontColor: '#000000'},
  '10-16': {value: '#00ffff', fontColor: '#000000'},
  '10-17': {value: '#0000ff', fontColor: '#ffffff'},
  '10-18': {value: '#ff00ff', fontColor: '#ffffff'},
  '10-19': {value: '#780000', fontColor: '#ffffff'},
  '10-20': {value: '#dc6600', fontColor: '#ffffff'},
  '10-21': {value: '#00b400', fontColor: '#ffffff'},
  '10-22': {value: '#50d278', fontColor: '#000000'},
  '10-23': {value: '#00288c', fontColor: '#ffffff'},
  '10-24': {value: '#dc00ff', fontColor: '#ffffff'},
  '11-1': {value: '#800000', fontColor: '#ffffff'},
  '11-2': {value: '#ff9955', fontColor: '#000000'},
  '11-3': {value: '#aad400', fontColor: '#000000'},
  '11-4': {value: '#536c53', fontColor: '#ffffff'},
  '11-5': {value: '#2c89a0', fontColor: '#ffffff'},
  '11-6': {value: '#5f5fd3', fontColor: '#ffffff'},
  '11-7': {value: '#aa0000', fontColor: '#ffffff'},
  '11-8': {value: '#d29955', fontColor: '#000000'},
  '11-9': {value: '#78c800', fontColor: '#000000'},
  '11-10': {value: '#327853', fontColor: '#ffffff'},
  '11-11': {value: '#2850b4', fontColor: '#ffffff'},
  '11-12': {value: '#8c5fd3', fontColor: '#ffffff'},
  '11-13': {value: '#800000', fontColor: '#ffffff'},
  '11-14': {value: '#ff9955', fontColor: '#000000'},
  '11-15': {value: '#aad400', fontColor: '#000000'},
  '11-16': {value: '#536c53', fontColor: '#ffffff'},
  '11-17': {value: '#2c89a0', fontColor: '#ffffff'},
  '11-18': {value: '#5f5fd3', fontColor: '#ffffff'},
  '11-19': {value: '#aa0000', fontColor: '#ffffff'},
  '11-20': {value: '#d29955', fontColor: '#000000'},
  '11-21': {value: '#78c800', fontColor: '#000000'},
  '11-22': {value: '#327853', fontColor: '#ffffff'},
  '11-23': {value: '#2850b4', fontColor: '#ffffff'},
  '11-24': {value: '#8c5fd3', fontColor: '#ffffff'},
  '12-1': {value: '#a02c2c', fontColor: '#ffffff'},
  '12-2': {value: '#a05a2c', fontColor: '#ffffff'},
  '12-3': {value: '#89a02c', fontColor: '#000000'},
  '12-4': {value: '#5fd38d', fontColor: '#000000'},
  '12-5': {value: '#87cdde', fontColor: '#000000'},
  '12-6': {value: '#7c6f91', fontColor: '#ffffff'},
  '12-7': {value: '#642c2c', fontColor: '#ffffff'},
  '12-8': {value: '#c85a2c', fontColor: '#ffffff'},
  '12-9': {value: '#50a02c', fontColor: '#ffffff'},
  '12-10': {value: '#5fff5a', fontColor: '#000000'},
  '12-11': {value: '#64aade', fontColor: '#000000'},
  '12-12': {value: '#aa6f91', fontColor: '#ffffff'},
  '12-13': {value: '#a02c2c', fontColor: '#ffffff'},
  '12-14': {value: '#a05a2c', fontColor: '#ffffff'},
  '12-15': {value: '#89a02c', fontColor: '#000000'},
  '12-16': {value: '#5fd38d', fontColor: '#000000'},
  '12-17': {value: '#87cdde', fontColor: '#000000'},
  '12-18': {value: '#7c6f91', fontColor: '#ffffff'},
  '12-19': {value: '#642c2c', fontColor: '#ffffff'},
  '12-20': {value: '#c85a2c', fontColor: '#ffffff'},
  '12-21': {value: '#50a02c', fontColor: '#ffffff'},
  '12-22': {value: '#5fff5a', fontColor: '#000000'},
  '12-23': {value: '#64aade', fontColor: '#000000'},
  '12-24': {value: '#aa6f91', fontColor: '#ffffff'},
  '13-1': {value: '#c83737', fontColor: '#ffffff'},
  '13-2': {value: '#e6cc00', fontColor: '#000000'},
  '13-3': {value: '#338000', fontColor: '#ffffff'},
  '13-4': {value: '#00ffcc', fontColor: '#000000'},
  '13-5': {value: '#0044aa', fontColor: '#ffffff'},
  '13-6': {value: '#7f2aff', fontColor: '#ffffff'},
  '13-7': {value: '#963737', fontColor: '#ffffff'},
  '13-8': {value: '#e6aa00', fontColor: '#000000'},
  '13-9': {value: '#335000', fontColor: '#ffffff'},
  '13-10': {value: '#00ff8c', fontColor: '#000000'},
  '13-11': {value: '#507878', fontColor: '#ffffff'},
  '13-12': {value: '#b478dc', fontColor: '#ffffff'},
  '13-13': {value: '#c83737', fontColor: '#ffffff'},
  '13-14': {value: '#e6cc00', fontColor: '#000000'},
  '13-15': {value: '#338000', fontColor: '#ffffff'},
  '13-16': {value: '#00ffcc', fontColor: '#000000'},
  '13-17': {value: '#0044aa', fontColor: '#ffffff'},
  '13-18': {value: '#7f2aff', fontColor: '#ffffff'},
  '13-19': {value: '#963737', fontColor: '#ffffff'},
  '13-20': {value: '#e6aa00', fontColor: '#000000'},
  '13-21': {value: '#335000', fontColor: '#ffffff'},
  '13-22': {value: '#00ff8c', fontColor: '#000000'},
  '13-23': {value: '#507878', fontColor: '#ffffff'},
  '13-24': {value: '#b478dc', fontColor: '#ffffff'},
  '14-1': {value: '#ff0066', fontColor: '#ffffff'},
  '14-2': {value: '#ffff00', fontColor: '#000000'},
  '14-3': {value: '#44aa00', fontColor: '#ffffff'},
  '14-4': {value: '#37c8ab', fontColor: '#000000'},
  '14-5': {value: '#2a7fff', fontColor: '#ffffff'},
  '14-6': {value: '#8c37c8', fontColor: '#ffffff'},
  '14-7': {value: '#c80066', fontColor: '#ffffff'},
  '14-8': {value: '#ffdc00', fontColor: '#000000'},
  '14-9': {value: '#447800', fontColor: '#ffffff'},
  '14-10': {value: '#78b48c', fontColor: '#000000'},
  '14-11': {value: '#28b4ff', fontColor: '#000000'},
  '14-12': {value: '#ab96c8', fontColor: '#000000'},
  '14-13': {value: '#ff0066', fontColor: '#ffffff'},
  '14-14': {value: '#ffff00', fontColor: '#000000'},
  '14-15': {value: '#44aa00', fontColor: '#ffffff'},
  '14-16': {value: '#37c8ab', fontColor: '#000000'},
  '14-17': {value: '#2a7fff', fontColor: '#ffffff'},
  '14-18': {value: '#8c37c8', fontColor: '#ffffff'},
  '14-19': {value: '#c80066', fontColor: '#ffffff'},
  '14-20': {value: '#ffdc00', fontColor: '#000000'},
  '14-21': {value: '#447800', fontColor: '#ffffff'},
  '14-22': {value: '#78b48c', fontColor: '#000000'},
  '14-23': {value: '#28b4ff', fontColor: '#000000'},
  '14-24': {value: '#ab96c8', fontColor: '#000000'},
  '15-1': {value: '#d35f5f', fontColor: '#ffffff'},
  '15-2': {value: '#c8ab37', fontColor: '#000000'},
  '15-3': {value: '#00ff0f', fontColor: '#000000'},
  '15-4': {value: '#00ccff', fontColor: '#000000'},
  '15-5': {value: '#284478', fontColor: '#ffffff'},
  '15-6': {value: '#ff80e5', fontColor: '#000000'},
  '15-7': {value: '#b45f5f', fontColor: '#ffffff'},
  '15-8': {value: '#c89637', fontColor: '#000000'},
  '15-9': {value: '#50dc50', fontColor: '#000000'},
  '15-10': {value: '#00e6e6', fontColor: '#000000'},
  '15-11': {value: '#282850', fontColor: '#ffffff'},
  '15-12': {value: '#dcaaaa', fontColor: '#000000'},
  '15-13': {value: '#d35f5f', fontColor: '#ffffff'},
  '15-14': {value: '#c8ab37', fontColor: '#000000'},
  '15-15': {value: '#00ff0f', fontColor: '#000000'},
  '15-16': {value: '#00ccff', fontColor: '#000000'},
  '15-17': {value: '#284478', fontColor: '#ffffff'},
  '15-18': {value: '#ff80e5', fontColor: '#000000'},
  '15-19': {value: '#b45f5f', fontColor: '#ffffff'},
  '15-20': {value: '#c89637', fontColor: '#000000'},
  '15-21': {value: '#50dc50', fontColor: '#000000'},
  '15-22': {value: '#00e6e6', fontColor: '#000000'},
  '15-23': {value: '#282850', fontColor: '#ffffff'},
  '15-24': {value: '#dcaaaa', fontColor: '#000000'},
  '16-1': {value: '#ff80b2', fontColor: '#000000'},
  '16-2': {value: '#786721', fontColor: '#ffffff'},
  '16-3': {value: '#7c916f', fontColor: '#000000'},
  '16-4': {value: '#6f8a91', fontColor: '#ffffff'},
  '16-5': {value: '#87aade', fontColor: '#000000'},
  '16-6': {value: '#b450ff', fontColor: '#ffffff'},
  '16-7': {value: '#dc80b2', fontColor: '#000000'},
  '16-8': {value: '#aa6721', fontColor: '#ffffff'},
  '16-9': {value: '#7cb46f', fontColor: '#000000'},
  '16-10': {value: '#6faa78', fontColor: '#000000'},
  '16-11': {value: '#aaaade', fontColor: '#000000'},
  '16-12': {value: '#b42aff', fontColor: '#ffffff'},
  '16-13': {value: '#ff80b2', fontColor: '#000000'},
  '16-14': {value: '#786721', fontColor: '#ffffff'},
  '16-15': {value: '#7c916f', fontColor: '#000000'},
  '16-16': {value: '#6f8a91', fontColor: '#ffffff'},
  '16-17': {value: '#87aade', fontColor: '#000000'},
  '16-18': {value: '#b450ff', fontColor: '#ffffff'},
  '16-19': {value: '#dc80b2', fontColor: '#000000'},
  '16-20': {value: '#aa6721', fontColor: '#ffffff'},
  '16-21': {value: '#7cb46f', fontColor: '#000000'},
  '16-22': {value: '#6faa78', fontColor: '#000000'},
  '16-23': {value: '#aaaade', fontColor: '#000000'},
  '16-24': {value: '#b42aff', fontColor: '#ffffff'},
};

export const HOVERED_WELL_COLOR = '#C0D6FB';
export const INACTIVE_WELL_COLOR = '#858585';
